import React, { useContext, useReducer, createContext, useEffect } from 'react'
import { ApplicationContext } from '../../contexts/ApplicationContext'
import reducer, { propsToState } from './reducer'
import { actionCreators } from './actions'

export const NotesContext = createContext(null)

export const NotesProvider = (props) => {
  const { trackingDetails } = useContext(ApplicationContext)
  const [internalState, dispatch] = useReducer(
    reducer,
    propsToState(props))
  const state = { ...internalState, ...props }
  const actionsWithDispatch = actionCreators(dispatch, state)
  const { updateProps } = actionsWithDispatch

  useEffect(
    () => updateProps(props),
    [props.notes]
  )

  return (
    <NotesContext.Provider value={{ state, trackingDetails, actions: actionsWithDispatch }}>
      {props.children}
    </NotesContext.Provider>
  )
}
